"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mountIsland_1 = require("../mountIsland");
var react_router_dom_1 = require("react-router-dom");
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var material_1 = require("@mui/material");
var icons_material_1 = require("@mui/icons-material");
var react_router_dom_2 = require("react-router-dom");
var Lang_js_1 = require("../Lang.js");
var SearchComponent = function (_a) {
    var _b = _a.defaultQuery, defaultQuery = _b === void 0 ? '' : _b, defaultResults = _a.defaultResults;
    var urlMaxLength = 100;
    var location = (0, react_router_dom_2.useLocation)();
    var getParams = new URLSearchParams(location.search);
    var queryParam = getParams.get('query');
    var navigate = (0, react_router_dom_2.useNavigate)();
    var _c = (0, react_1.useState)(defaultQuery || queryParam || ''), query = _c[0], setQuery = _c[1];
    var _d = (0, react_1.useState)(query.trim().length > 0), haveSearched = _d[0], setHaveSearched = _d[1];
    var _f = (0, react_1.useState)((defaultResults === null || defaultResults === void 0 ? void 0 : defaultResults.search_results) || []), results = _f[0], setResults = _f[1];
    var _g = (0, react_1.useState)([]), autocompleteResults = _g[0], setAutocompleteResults = _g[1];
    var _h = (0, react_1.useState)((defaultResults === null || defaultResults === void 0 ? void 0 : defaultResults.featured_content) || []), featured = _h[0], setFeatured = _h[1];
    var _j = (0, react_1.useState)(false), loading = _j[0], setLoading = _j[1];
    var _k = (0, react_1.useState)(null), error = _k[0], setError = _k[1];
    var _l = (0, react_1.useState)((defaultResults === null || defaultResults === void 0 ? void 0 : defaultResults.page) || 1), currentPage = _l[0], setCurrentPage = _l[1];
    var _m = (0, react_1.useState)((defaultResults === null || defaultResults === void 0 ? void 0 : defaultResults.pages) || 1), totalPages = _m[0], setTotalPages = _m[1];
    var iconFromUrl = function (url, props) {
        if (url.includes('/newdayherald/') || url.includes('/nuevoamanecer/')) {
            return react_1.default.createElement(icons_material_1.Newspaper, __assign({}, props));
        }
        else if (url.includes('/events/') || url.includes('/eventos/')) {
            return react_1.default.createElement(icons_material_1.Event, __assign({}, props));
        }
        else if (url.includes('/shop/') || url.includes('/tienda/')) {
            return react_1.default.createElement(icons_material_1.ShoppingCart, __assign({}, props));
        }
        else if (url.includes('/quotes/') || url.includes('/citas/')) {
            return react_1.default.createElement(icons_material_1.FormatQuote, __assign({}, props));
        }
        else if (url.includes('/media/') || url.includes('/medios/')) {
            return react_1.default.createElement(icons_material_1.OndemandVideo, __assign({}, props));
        }
        else if (url.includes('/john-roger-library/')) {
            return react_1.default.createElement(icons_material_1.MenuBook, __assign({}, props));
        }
        else {
            return react_1.default.createElement(icons_material_1.Article, __assign({}, props));
        }
    };
    var updateUrl = function (searchQuery, page) {
        var params = new URLSearchParams();
        params.set('query', searchQuery);
        params.set('page', page.toString());
        navigate({ search: params.toString() });
    };
    var handleAutocomplete = function (searchQuery) { return __awaiter(void 0, void 0, void 0, function () {
        var response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (searchQuery === false) {
                        setAutocompleteResults([]);
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios_1.default.get("/api/autocomplete", {
                            params: {
                                term: searchQuery,
                                lang: Lang_js_1.lang,
                            },
                        })];
                case 2:
                    response = _a.sent();
                    if (response.data.length > 0) {
                        setAutocompleteResults(response.data);
                    }
                    else {
                        setAutocompleteResults([]);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    setAutocompleteResults([]);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleSearch = function (searchQuery, page) {
        if (searchQuery === void 0) { searchQuery = query; }
        if (page === void 0) { page = currentPage; }
        return __awaiter(void 0, void 0, void 0, function () {
            var userCountryCode, response, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (searchQuery.trim().length === 0) {
                            return [2 /*return*/];
                        }
                        setHaveSearched(true);
                        setLoading(true);
                        setError(null);
                        setResults([]);
                        setFeatured([]);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        updateUrl(searchQuery, page);
                        userCountryCode = navigator.language.split('-')[1] || 'US';
                        return [4 /*yield*/, axios_1.default.get("/api/search", {
                                params: {
                                    query: searchQuery,
                                    page: page,
                                    user_country_code: userCountryCode,
                                },
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.data.status === 'success') {
                            setFeatured(response.data.featured_content);
                            setResults(response.data.search_results);
                            setTotalPages(response.data.pages);
                            setCurrentPage(response.data.page);
                        }
                        else {
                            setError((0, Lang_js_1.__)('Failed to fetch search results.'));
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        err_2 = _a.sent();
                        if (err_2.response) {
                            setError(err_2.response.data.message);
                        }
                        else {
                            setError((0, Lang_js_1.__)('An error occurred while fetching search results.'));
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return (react_1.default.createElement(material_1.Container, { maxWidth: "md", style: { marginTop: '2rem' } },
        react_1.default.createElement(material_1.Typography, { variant: "h4", gutterBottom: true, "aria-label": "Search", style: { display: 'none' } }, (0, Lang_js_1.__)('Search')),
        react_1.default.createElement(material_1.Grid, { container: true },
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12, md: 9 },
                react_1.default.createElement(material_1.Autocomplete, { freeSolo: true, options: autocompleteResults, 
                    /* wrap the query portion in strong tag */
                    renderOption: function (_a, option) {
                        var key = _a.key, props = __rest(_a, ["key"]);
                        var newOption = option.replace(query, '<strong>' + query.replace(' ', '&nbsp;').toLowerCase() + '</strong>');
                        return (react_1.default.createElement("li", __assign({ key: key }, props),
                            react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: newOption } })));
                    }, inputValue: query, onInputChange: function (_e, newValue) {
                        if (window.autocompleteHandler) {
                            window.clearTimeout(window.autocompleteHandler);
                        }
                        setQuery(newValue);
                        if (newValue.trim().length >= 3) {
                            window.autocompleteHandler = window.setTimeout(function () {
                                handleAutocomplete(newValue);
                            }, 500);
                        }
                        else {
                            handleAutocomplete(false);
                        }
                    }, onChange: function (_e, newValue) {
                        if (newValue) {
                            setQuery(newValue);
                            handleSearch(newValue);
                        }
                    }, renderInput: function (params) { return (react_1.default.createElement(material_1.TextField, __assign({}, params, { fullWidth: true, label: (0, Lang_js_1.__)('Enter your query'), name: "search", margin: "none", autoFocus: true, sx: {
                            fontSize: '2rem',
                            '& .MuiAutocomplete-endAdornment': {
                                padding: '0',
                                height: '36px',
                                position: 'absolute',
                                right: '9px',
                                top: 'calc(50% - 8px)'
                            },
                            '& .MuiAutocomplete-clearIndicator': {
                                visibility: 'visible',
                                width: '36px',
                                height: '36px'
                            },
                            '& .MuiInputBase-root': {
                                paddingLeft: '0',
                            },
                            '& .MuiInputBase-input': {
                                fontSize: '1.5rem',
                                height: '4rem',
                            },
                            '& .MuiAutocomplete-input': {
                                padding: '0.5rem 1rem!important',
                            },
                        } }))); } })),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12, md: 3 },
                react_1.default.createElement(material_1.Button, { type: "submit", variant: "contained", color: "primary", onClick: function (e) { e.preventDefault(); handleSearch(); }, disabled: loading, style: {
                        marginTop: '0.5rem',
                        padding: '1rem 2rem',
                        height: '4rem',
                        fontSize: '1rem',
                        width: '100%',
                    } }, loading ? react_1.default.createElement(material_1.CircularProgress, { size: 24 }) : (0, Lang_js_1.__)('Search')))),
        (error && (react_1.default.createElement(material_1.Alert, { severity: "error" }, error)))
            ||
                (haveSearched && results.length == 0 && featured.length == 0 && query.trim().length > 0 && !loading && (react_1.default.createElement(material_1.Typography, { variant: "body1" }, (0, Lang_js_1.__)('No results for "%s"').replace('%s', query)))),
        (results.length > 0 || (featured.length > 0 && currentPage == 1)) && (react_1.default.createElement(material_1.Typography, { variant: "h5", gutterBottom: true, sx: { marginTop: '2rem' } }, (0, Lang_js_1.__)('Search Results'))),
        featured.length > 0 && currentPage == 1 && (react_1.default.createElement("div", { style: { marginTop: '2rem' } }, featured.map(function (item) { return (react_1.default.createElement(material_1.Card, { key: item.id, style: { marginBottom: '1.5rem', backgroundColor: '#f8f9fa' } },
            react_1.default.createElement(material_1.CardContent, null,
                react_1.default.createElement(material_1.Typography, { variant: "h6", sx: {} },
                    react_1.default.createElement(material_1.Link, { href: item.url, sx: {
                            textDecoration: 'none',
                            borderBottom: '1px solid #5E309F',
                        } },
                        iconFromUrl(item.url, { sx: {
                                marginRight: '0.25em',
                                fontSize: '1em',
                                display: 'inline',
                                position: 'relative',
                                bottom: '0.125em;'
                            } }),
                        item.title)),
                react_1.default.createElement(material_1.Typography, { variant: "body1", sx: { margin: '0.75em auto' }, dangerouslySetInnerHTML: { __html: item.description || (0, Lang_js_1.__)('No description available.') } }),
                react_1.default.createElement(material_1.Typography, { variant: "body2", color: "textSecondary" }, item.url.length > urlMaxLength ? item.url.substring(0, urlMaxLength) + '...' : item.url)))); }))),
        results.length > 0 && (react_1.default.createElement("div", { style: { marginTop: '2rem' } }, results.map(function (item) {
            var _a;
            return (react_1.default.createElement(material_1.Card, { key: item.id, style: { marginBottom: '1.5rem' } },
                react_1.default.createElement(material_1.CardContent, null,
                    react_1.default.createElement(material_1.Typography, { variant: "h6", sx: {} },
                        react_1.default.createElement(material_1.Link, { href: item.document.derivedStructData.link, sx: {
                                textDecoration: 'none',
                                borderBottom: '1px solid #5E309F',
                            } },
                            iconFromUrl(item.document.derivedStructData.link, { sx: {
                                    marginRight: '0.25em',
                                    fontSize: '1em',
                                    display: 'inline',
                                    position: 'relative',
                                    bottom: '0.125em;'
                                } }),
                            item.document.derivedStructData.title)),
                    react_1.default.createElement(material_1.Typography, { variant: "body1", sx: { margin: '0.75em auto' }, dangerouslySetInnerHTML: { __html: ((_a = item.document.derivedStructData.snippets[0]) === null || _a === void 0 ? void 0 : _a.snippet) || (0, Lang_js_1.__)('No description available.') } }),
                    react_1.default.createElement(material_1.Typography, { variant: "body2", color: "textSecondary" }, item.document.derivedStructData.link.length > urlMaxLength ? item.document.derivedStructData.link.substring(0, urlMaxLength) + '...' : item.document.derivedStructData.link))));
        }))),
        totalPages > 1 && (react_1.default.createElement(material_1.Pagination, { count: totalPages, page: currentPage, onChange: function (e, value) {
                e.preventDefault();
                setCurrentPage(value);
                handleSearch(query, value);
            }, color: "primary", siblingCount: 1, boundaryCount: 1, showFirstButton: true, showLastButton: true, style: { marginTop: '1rem', display: 'flex', justifyContent: 'center' } }))));
};
var searchContainer = document.getElementById('search-container');
if (searchContainer) {
    var query = searchContainer.getAttribute('data-query');
    var results = JSON.parse(searchContainer.getAttribute('data-results'));
    (0, mountIsland_1.mountIsland)(searchContainer, react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
        react_1.default.createElement(SearchComponent, { defaultQuery: query, defaultResults: results })));
}
